import { z } from 'zod'
import { oc } from '@orpc/contract'
import { practitionerRowSchema } from './list-practitioners.contract'
import {
  caqhProfileSchema,
  liabilityCoverageSchema,
  payerEnrollmentRowSchema,
  practitionerPhotoSchema,
} from './member-credentials.contract'

/**
 * One Org Member for the Provider Operations detail page: the list row plus the
 * Organization the caller may manage them in. The Organization is derived from the
 * practitioner's own active PractitionerRole; a caller with no Provider Operations scope
 * over it gets 403 (see `practitioner-ops-access.ts`).
 */
export const getPractitioner = oc
  .route({ method: 'GET', path: '/v2/practitioners/{practitionerId}' })
  .input(
    z.object({
      practitionerId: z.string().min(1),
      // The Organization the page was opened from. Only disambiguates a target with roles
      // in more than one Organization; never widens access (`practitioner-ops-access.ts`).
      organizationId: z.string().min(1).optional(),
    }),
  )
  .output(
    practitionerRowSchema.extend({
      organizationId: z.string(),
      organizationName: z.string(),
      // Get-one only: the list rows carry no photo, coverage or CAQH Profile. `null` when none
      // is stored.
      photo: practitionerPhotoSchema.nullish(),
      liability: liabilityCoverageSchema.nullish(),
      caqh: caqhProfileSchema.nullish(),
      // The Payer Enrollments in stored order; empty when none is.
      payerEnrollments: z.array(payerEnrollmentRowSchema),
    }),
  )
